import { render, staticRenderFns } from "./error.vue?vue&type=template&id=1701d2bd"
import script from "./error.vue?vue&type=script&lang=js"
export * from "./error.vue?vue&type=script&lang=js"
import style0 from "./error.vue?vue&type=style&index=0&id=1701d2bd&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Back: require('/app/components/back.vue').default,Header: require('/app/components/header.vue').default,Sidebar: require('/app/components/sidebar.vue').default,ToastGeneral: require('/app/components/toastGeneral.vue').default})
